import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import * as History from 'history';
import { default as EN } from './common/lang/en';
import { default as ZH } from './common/lang/zh';
import { default as Login } from './routes/login/login';
import { default as Layout } from './routes/layout/layout';
import { default as Announcement } from './routes/announcement/announcement';
import * as paths from './common/paths';
import "antd/dist/antd.css";

const defaultHistory = History.createBrowserHistory();

const langMapping = {
  en: EN,
  zh: ZH,
};

const App = props => (
  <IntlProvider locale="zh" messages={langMapping.zh as any}>
    <Switch history={props.history || defaultHistory}>
      <Route path={paths.LOGIN_PATH}>
        <Login history={props.history || defaultHistory} {...props} />
      </Route>
      <Route path={paths.PYXIS_PATH}>
        <Layout history={props.history || defaultHistory} {...props} />
      </Route>
      <Route path={paths.ANNOUNCEMENT_PATH}>
        <Announcement history={props.history || defaultHistory} {...props} />
      </Route>
      <Redirect to={paths.PYXIS_PATH}/>
    </Switch>
  </IntlProvider>
);

export default App;
